// import get from 'lodash/get';
import { handleError } from 'helper/rest';
import { client } from 'helper/axios';
// import { setCookie } from 'helper/cookie';
// import { parseJWT } from 'helper/jwt';
// import Swal from 'sweetalert2';
// import Color from 'constants/color.constants';

export const getTypeNumberAll = async ({ token, params } : any) => {
   try {
      return await client
         .get(`type_number`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
            params,
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};

export const getTypeNumberById = async ({ token, params } : any) => {
   try {
      return await client
         .get(`type_number/${params?.id}`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};

export const getTypeNumberByCode = async ({ token, params } : any) => {
   try {
      return await client
         .get(`type_number_code/${params?.code}`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};

export const getTypeNumberByCodeOnly = async ({ token, params } : any) => {
   try {
      return await client
         .get(`type_number_code_only/${params?.code}`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};

export const postCreateTypeNumber = async ({ token, params } : any) => {
   try {
      return await client
         .post(`type_number`, params, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};


export const putUpdateTypeNumber = async ({ token, params, id } : any) => {
   try {
      return await client
         .put(`type_number/${id}`, params, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};

export const deleteTypeNumber = async ({ token, id } : any) => {
   try {
      return await client
         .delete(`type_number/${id}`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};
